"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var CommodityTag_1 = __importDefault(require("../CommodityTag/CommodityTag"));
var TextInput_1 = __importDefault(require("../TextInput/TextInput"));
var Autocomplete_styles_1 = require("../Autocomplete/Autocomplete.styles");
var FormStringConcat = function (_a) {
    var id = _a.id, label = _a.label, _b = _a.margin, margin = _b === void 0 ? "normal" : _b, error = _a.error, highlight = _a.highlight, _c = _a.translate, translate = _c === void 0 ? "no" : _c, value = _a.value, onChange = _a.onChange, _d = _a.TextInputProps, TextInputProps = _d === void 0 ? {} : _d, props = __rest(_a, ["id", "label", "margin", "error", "highlight", "translate", "value", "onChange", "TextInputProps"]);
    var classes = Autocomplete_styles_1.useAutocompleteStyles();
    var internalValue = value ? value.split(",") : [];
    return (react_1.default.createElement(Autocomplete_1.default, __assign({}, props, { multiple: true, id: "form-commodities" + (id ? "-" + id : ""), freeSolo: true, fullWidth: true, disableClearable // this prop will remove padding right for CloseIcon
        : true, forcePopupIcon: false, autoSelect: true, classes: classes, value: internalValue, onChange: function (event, newValue) { return onChange(newValue.join(",")); }, options: [], getOptionLabel: function (option) { return option; }, renderTags: function (tagValue) {
            return tagValue.map(function (name, i) { return (react_1.default.createElement(CommodityTag_1.default, { onDelete: function () {
                    var filterdValue = internalValue.filter(function (_, index) { return i !== index; });
                    onChange(filterdValue.join(","));
                }, key: i, style: { marginLeft: "6px" } },
                react_1.default.createElement(Typography_1.default, { variant: "body2" }, name))); });
        }, renderInput: function (params) { return (react_1.default.createElement(TextInput_1.default, __assign({}, params, { error: error, highlight: highlight, label: label, margin: margin, translate: translate }, TextInputProps, { InputLabelProps: __assign(__assign({}, params.InputLabelProps), TextInputProps.InputLabelProps), InputProps: __assign(__assign({}, params.InputProps), TextInputProps.InputProps), placeholder: !internalValue.length ? "Enter your commodities. . ." : "Add more" }))); } })));
};
exports.default = FormStringConcat;
//# sourceMappingURL=FormStringConcat.js.map